// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"7751ad7a","373":"a6595302","787":"6de9dcf1","789":"c926881a","984":"b7612dcf"}[chunkId] + ".chunk.js";
};